<template>
  <div class="w-100">
    <div class="card-one d-flex">
      <div
        class="card p-0 shadow"
        style="border-radius: 15px; width: -webkit-fill-available"
      >
        <div class="card-header p-0">
          <div class="sd-heading">
            <img
              src="../../../assets/logo.jpg"
              alt="Profile Picture"
              class="profile-pic"
            />
          </div>
        </div>
        <div class="sd-body p-a-16">
          <b class="f-Overpass">
            Selamat Datang di <span class="f-c-blue f-Overpass f-16">scan.smartlink.id</span>
          </b>
          <p class="f-Overpass f-14 f-w-400 f-c-black p-t-8 m-0">
            Silahkan masuk atau daftar menggunakan nomor WhatsApp untuk mulai
            bertransaksi di outlet langganan anda
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "indexCard",
};
</script>

<style scoped>
.card-one {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  align-items: center;
  width: -webkit-fill-available;
}

.profile-pic {
  width: 110px; /* Set the width and height of the circular image */
  height: 110px;
  border-radius: 70%; /* Create a circular shape */
  position: absolute; /* Position the image absolutely */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 1%;
  left: 50%; /* Position horizontally at the center */
  transform: translate(-50%, -50%);
}

.sd-heading {
  background-color: #206cfe;
  height: 70px;
  color: #fff;
  align-self: stretch;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

/* .spsl-1 {
  color: #206cfe;
  font-size: 16px;
} */
</style>
